import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcoAlertErrorWhite = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.6 0C0.716344 0 0 0.716345 0 1.6V14.4C0 15.2837 0.716345 16 1.6 16H14.4C15.2837 16 16 15.2837 16 14.4V1.6C16 0.716344 15.2837 0 14.4 0H1.6ZM6.66667 2.93333C6.66667 2.63878 6.90545 2.4 7.2 2.4H8.8C9.09455 2.4 9.33333 2.63878 9.33333 2.93333V8.8C9.33333 9.09455 9.09455 9.33333 8.8 9.33333H7.2C6.90545 9.33333 6.66667 9.09455 6.66667 8.8V2.93333ZM6.66667 10.9333C6.66667 10.6388 6.90545 10.4 7.2 10.4H8.8C9.09455 10.4 9.33333 10.6388 9.33333 10.9333V12.5333C9.33333 12.8279 9.09455 13.0667 8.8 13.0667H7.2C6.90545 13.0667 6.66667 12.8279 6.66667 12.5333V10.9333Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgIcoAlertErrorWhite);
export { ForwardRef as ReactComponent };
